import Button from '../../../components/ui/Button';
import type { WidgetStateSnapshot } from '../../lab/WidgetRenderer';

interface WidgetAnswerProps {
  snapshot: WidgetStateSnapshot | null;
  disabled?: boolean;
  submitted?: boolean;
  onSubmit: () => void;
}

// WIP-016 (design §8.3) — the response control for a step whose answer is a
// lab widget's own state. The widget itself is rendered by `StepPrompt`
// (which is where `onStateChange` fires — see its comment for why); this is
// just the "Submit this answer" button and the widget's own one-line display
// form echoed beside it, so the student sees exactly what they are about to
// send before they send it. Same rule the instructor's table follows: store
// what is needed, display what can be scanned.
export default function WidgetAnswer({ snapshot, disabled, submitted, onSubmit }: WidgetAnswerProps) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-md border border-ws-border bg-ws-surface-2 px-3 py-2">
      <p className="min-w-0 flex-1 truncate text-xs text-ws-ink-2" title={snapshot?.display}>
        {snapshot ? snapshot.display : 'Build your answer above, then submit.'}
      </p>
      <Button size="sm" onClick={onSubmit} disabled={disabled || submitted || !snapshot}>
        Submit this answer
      </Button>
    </div>
  );
}
